export default "__VITE_ASSET__bc948103__"